"use client";
import clsx from "clsx";
import type { CSSProperties, ReactNode } from "react";

type Props = {
  children: ReactNode;
  direction: "left" | "right";
  count: number;
};

export const InfiniteCarouselRow = ({ children, direction, count }: Props) => {
  return (
    <div className="flex w-full overflow-x-clip select-none pointer-events-none">
      <div
        className={clsx("flex shrink-0 items-center will-change-transform", {
          "animate-infinite-scroll-left": direction === "left",
          "animate-infinite-scroll-right": direction === "right",
        })}
        style={
          {
            "--infinite-duration": `${count * 12}s`,
          } as CSSProperties
        }
      >
        <div className="flex gap-6 pr-6">{children}</div>
        <div className="flex gap-6 pr-6">{children}</div>
      </div>
    </div>
  );
};
